import { createSlice, Reducer, Slice } from "@reduxjs/toolkit";

import TradeSpendReportTabSlice from "../../models/Redux/TradeSpendReportTabSlice.model";
import { TradeSpendReportSelectedSlicerModel } from "../../models/TradeAndPromoPlanning/TradeSpendReportSlicer.model";
import { getDefaultSlicersForForecastEntryApp } from "../../shared/functions";
import { TRADE_SPEND_REPORT_TAB_ID } from "../../shared/constants";

const defaultSlicers: TradeSpendReportSelectedSlicerModel = getDefaultSlicersForForecastEntryApp(TRADE_SPEND_REPORT_TAB_ID);

const initialState: TradeSpendReportTabSlice = {
    tempSelectedSlicers: defaultSlicers,
    selectedSlicers: defaultSlicers,
    slicers: {
        skus: [],
        brands: [],
        promotions: []
    }
};

const tradeSpendReportTabSlice: Slice = createSlice({
    name: "tradeSpendReportTab",
    initialState,
    reducers: {
        setSlicers: (state: TradeSpendReportTabSlice, action: { payload: any }) => {
            state.slicers = action.payload;
        },
        setTempSelectedSlicers: (state: TradeSpendReportTabSlice, action: { payload: any }) => {
            state.tempSelectedSlicers = action.payload;
        },
        setSelectedSlicers: (state: TradeSpendReportTabSlice, action) => {
            state.selectedSlicers = action.payload;
        },
        resetSelectedSlicers: (state: TradeSpendReportTabSlice, action) => {
            state.tempSelectedSlicers = structuredClone(defaultSlicers);
            state.selectedSlicers = structuredClone(defaultSlicers);
        }
    }
});

export const tradeSpendReportTabAction = tradeSpendReportTabSlice.actions;

export default tradeSpendReportTabSlice.reducer as Reducer<TradeSpendReportTabSlice>;
